import { axiosGetHandler, axiosHandler, axiosConfig } from '@/api/common_helpers.js';
import { MEMBER_MEMBER_INFO_URL, MEMBER_PAYMENT_HELPERS_URL, IS_UI_ONLY_MODE, CAMPAIGN_TRIAL_TYPE_KEY } from '@/main.js';

export const getMemberInfo = async (userId, token) => {
  try {
    if (IS_UI_ONLY_MODE) {
      console.log("UI_ONLY_MODE", "get", `${MEMBER_MEMBER_INFO_URL}?userid=${userId}`, token)
      return {
        data: {
          name: 'UI_ONLY_MODE',
          initialTrialDate: null,
          planId: 4,
          managedByIAP: 0,
          trialType: CAMPAIGN_TRIAL_TYPE_KEY,
          campaignId: null,
          status: 10
        }, isSuccess: true
      }
    }
    const response = await axiosGetHandler(`${MEMBER_MEMBER_INFO_URL}?userid=${encodeURIComponent(userId)}`, axiosConfig(token));
    // console.log("getMemberInfo response data", response.data)
    return {
      data: response.data,
      isSuccess: !response.data.message || response.data.message !== "Empty user record"
    }
  } catch (error) {
    console.error('getMemberInfo', error);
    // throw new Error(error);
    return { isSuccess: false }
  }
};

export const postMemberInfo = async (userId, params) => {
  try {
    const postData = {
      action: 'updateProfile',
      userId,
      ...params
    };
    if (IS_UI_ONLY_MODE) {
      console.log("UI_ONLY_MODE", "post", MEMBER_MEMBER_INFO_URL, postData)
      return true
      // return { isSuccessful: true, statusMessage: "" }
    }
    const response = await axiosHandler(MEMBER_MEMBER_INFO_URL, postData, axiosConfig());
    const { statusCode } = response.data
    return statusCode === 0;
  } catch (error) {
    console.error('postMemberInfo', error);
    throw new Error(error);
  }
};

export const getStripeCustomerData = async ({ customerId, isProduction, userId, token }) => {
  try {
    const postData = {
      action: 'customer_info',
      customer_id: customerId,
      ...(isProduction ? {} : { debug: true })
    };
    if (IS_UI_ONLY_MODE) {
      console.log("UI_ONLY_MODE", "post", `${MEMBER_PAYMENT_HELPERS_URL}?userid=${userId}`, postData)
      return "1"
      // return { isSuccessful: true, statusMessage: "" }
    }
    const response = await axiosHandler(`${MEMBER_PAYMENT_HELPERS_URL}?userid=${userId}`, postData, axiosConfig(token));
    const { data } = response
    const { default_payment_method: defaultCardId } = (data.invoice_settings || {})
    return defaultCardId;
  } catch (error) {
    console.error('getObject', error);
    // throw new Error(error);
  }
};

export const getListOfCards = async ({ customerId, isProduction, userId, token, defaultCardId }) => {
  try {
    const postData = {
      action: 'list_cards',
      customer_id: customerId,
      ...(isProduction ? {} : { debug: true })
    };
    if (IS_UI_ONLY_MODE) {
      console.log("UI_ONLY_MODE", "post", `${MEMBER_PAYMENT_HELPERS_URL}?userid=${userId}`, postData)
      return {}
      // return { isSuccessful: true, statusMessage: "" }
    }
    const response = await axiosHandler(`${MEMBER_PAYMENT_HELPERS_URL}?userid=${userId}`, postData, axiosConfig(token));
    const { data } = response
    let defaultCardObject = null
    const creditCards = (data.data || []).map(({ id, card }) => {
      const { brand, last4 } = card
      const cardObject = { id, brand, last4 }
      if (id === defaultCardId) {
        defaultCardObject = cardObject
      }
      return cardObject
    })
    return { creditCards, defaultCardId, defaultCardObject }
  } catch (error) {
    console.error('getListOfCards', error);
    // throw new Error(error);
  }
};

export const getSetupIntent = async ({ customerId, isProduction, userId, token }) => {
  try {
    const postData = {
      action: 'setup_intent',
      customer_id: customerId,
      ...(isProduction ? {} : { debug: true })
    };
    if (IS_UI_ONLY_MODE) {
      console.log("UI_ONLY_MODE", "post", `${MEMBER_PAYMENT_HELPERS_URL}?userid=${userId}`, postData)
      // return { isSuccessful: true, statusMessage: "" }
      return "asddsa"
    }
    const response = await axiosHandler(`${MEMBER_PAYMENT_HELPERS_URL}?userid=${userId}`, postData, axiosConfig(token));
    const { data } = response;
    const clientSecret = data.client_secret;
    return clientSecret;
  } catch (error) {
    console.error('getSetupIntent', error);
    // throw new Error(error);
  }
};

export const setDefaultCard = async (paymentMethodId, { customerId, isProduction, userId, token }) => {
  try {
    const postData = {
      action: 'update_payment',
      customer_id: customerId,
      payment_method_id: paymentMethodId,
      ...(isProduction ? {} : { debug: true })
    };
    if (IS_UI_ONLY_MODE) {
      console.log("UI_ONLY_MODE", "post", `${MEMBER_PAYMENT_HELPERS_URL}?userid=${userId}`, postData)
      // return { isSuccessful: true, statusMessage: "" }
      return {}
    }
    const response = await axiosHandler(`${MEMBER_PAYMENT_HELPERS_URL}?userid=${userId}`, postData, axiosConfig(token));
    const { data } = response;
    return data;
  } catch (error) {
    console.error('setDefaultCard', error);
    // throw new Error(error);
  }
};